import CustomerNotesCardEmpty from '../CustomerNotesCardEmpty/CustomerNotesCardEmpty'
import CustomerNotesCardError from '../CustomerNotesCardError/CustomerNotesCardError'
import CustomerNotesCardSkeleton from '../CustomerNotesCardSkeleton/CustomerNotesCardSkeleton'
import { analysisState } from '../hooks/useCustomerNotesAnalysis/constants'
import OverallSentiment from '../OverallSentiment/OverallSentiment'
import TopTopicsList from '../TopTopicsList/TopTopicsList'
import * as Styles from './styles'

const CustomerNotesCardContent = ({ data, refetch, onClickTopic }) => {
  if (!data || data.state === analysisState.computing) return <CustomerNotesCardSkeleton />

  if (data.state === analysisState.empty) return <CustomerNotesCardEmpty />

  if (data.state === analysisState.error || !data.payload) return <CustomerNotesCardError onRetry={refetch} />

  return (
    <Styles.Container>
      <OverallSentiment sentiment={data.payload.sentiment} totalNotes={data.payload.total_notes} />
      <TopTopicsList topics={data.payload.topics} onClickTopic={onClickTopic} />
    </Styles.Container>
  )
}

export default CustomerNotesCardContent
